import React from 'react'
import 'App.css'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Login from "./pages/Login";
import Home from "./pages/Home";
import PrivateRouter from './routers/PrivateRouter';
import OrderList from 'pages/OrderList';
// import AllProjects from 'pages/product/AllProjects';
// banner
import BannerList from 'pages/banner/List';
import AddBanner from 'pages/banner/Add';
import UpdateBanner from 'pages/banner/Update';
//users
import UsersList from 'pages/users/UsersList';
import AddUser from 'pages/users/AddUser';
import UpdateUser from 'pages/users/UpdateUser';
import AddCustomer from 'pages/customer/AddCustomer';
import LiveVideoList from 'pages/liveVideo/List';
import AddLiveVideo from 'pages/liveVideo/Add';
// import UpdateCustomer from 'pages/customer/UpdateCustomer';
import BillList from 'components/billing/BillList';
import BillDetails from 'components/billing/BillDetails';
import CorderList from 'pages/orderList/CorderList';
import CreateBill from 'components/billing/CreateBill';
import ListNumber from 'pages/gussingnumbers/ListNumber';
import GameBids from 'pages/gamebids/GameBids'
import Withdrawel from 'pages/orderList/Withdrawel';
import ListPlay from 'pages/customer_play/ListPlay';
import QrCodeList from 'pages/qrcodes/QrCodeList';
import WalletCustomerList from 'pages/customer/WalletCustomerList';
import UserLogin from 'pages/UserLogin';
import QuestionList from 'pages/questions/QuestionList';
import AddQuestions from 'pages/questions/AddQuestions';
import QuestionUpdate from 'pages/questions/QuestionUpdate';
import Servicemen from 'pages/servicemen/Servicemen';
import AddServiceMen from 'pages/servicemen/AddServiceMen'

import CategoryList from 'pages/category/CategoryList';
import AddCategory from 'pages/category/AddCategory';
import UpdateCategory from 'pages/category/UpdateCategory';
import ServiceManWorkDetails from 'pages/servicemen/ServiceManWorkDetails';
import LiveTracking from 'pages/tracking/LiveTracking';
import AllCustomers from 'pages/customer/AllCustomers';
import AddProject from 'pages/project/AddProject';
import UpdateProject from 'pages/project/UpdateProject';
import AllProjects from 'pages/project/AllProjects';
import ProjectContentUpdate from 'pages/project/ProjectContentUpdate';
import Packages from 'pages/packages/Packages';
import ExpertCallingList from 'pages/ExpertCalling/ExpertCallingList';
import AddExpertCalling from 'pages/ExpertCalling/AddExpertCalling';
import AddPackage from 'pages/packages/AddPackage';
import AllBlogs from 'pages/blogs/AllBlogs';
import CreateBlog from 'pages/blogs/CreateBlog';
import AllTestimonials from 'pages/testimonials/AllTestimonials';
import CreateTestimonial from 'pages/testimonials/CreateTestimonial';
import SiteSetupList from 'pages/sitesetup/list';
import AddSiteSetup from 'pages/sitesetup/add';
import UpdateSiteSetup from 'pages/sitesetup/update';

// Commercial Service
import CommercialServiceList from 'pages/CommercialService/list';
import AddCommercialService from 'pages/CommercialService/add';
import UpdateCommercialService from 'pages/CommercialService/update';

function App() {
  return (
    <Router>
      <>
        <Routes>
          <Route path="/signin" element={<Login />} />
          <Route path="/userlogin" element={<UserLogin />} />
          <Route path="/" element={<Login />} />
        </Routes>
      </>
      <Routes>
        <Route element={<PrivateRouter />}>
          <Route path="/dashboard" element={<Home />} />
          <Route path="/orderlist" element={<OrderList />} />

          {/* Commercial Service */}
          <Route path="/commercial-services" element={<CommercialServiceList />} />
          <Route path="/commercial-services/add" element={<AddCommercialService />} />
          <Route path="/commercial-services/update/:id" element={<UpdateCommercialService />} />

          {/* Site Setup */}
          <Route path="/sitesetup" element={<SiteSetupList />} />
          <Route path="/sitesetup/add" element={<AddSiteSetup />} />
          <Route path="/sitesetup/update/:id" element={<UpdateSiteSetup />} />

          {/* this is new router for the serviceman app */}
          <Route path="/projects" element={<AllProjects />} />
          <Route path="/projects/add" element={<AddProject />} />
          <Route path="/projects/update/:id" element={<UpdateProject />} />
          <Route path="/projects/content-update" element={<ProjectContentUpdate />} />
          
          {/* Package */}
          <Route path="/packages" element={<Packages />} />
          <Route path="/packages/add" element={<AddPackage/>} />

           {/* testimonials */}
          <Route path="/testimonials" element={<AllTestimonials />} />
          <Route path="/testimonials/add" element={<CreateTestimonial />} />


          {/* user  */}
          <Route path="/users" element={<UsersList />} />
          <Route path="/users/add" element={<AddUser />} />
          <Route path="/users/update/:id" element={<UpdateUser />} />

          {/* Expert Calling */}

          <Route path="/expertcalling" element={<ExpertCallingList />} />
          <Route path="/expertcalling/add" element={<AddExpertCalling />} />

          {/* Blogs */}
          <Route path="/blogs" element={<AllBlogs />} />
          <Route path="/blogs/add" element={<CreateBlog />} />


          {/* Customer */}
          <Route path="/contactus" element={<AllCustomers/>} />
          <Route path="/contactus/add" element={<AddCustomer />} />
          {/* <Route path="/customer/update/:id" element={<UpdateCustomer />} /> */}
          <Route path="/customer/wallethistory/:id" element={<WalletCustomerList />} />

          {/* service man  */}
          <Route path="/addservicemen" element={<AddServiceMen />} />
          <Route path="/servicemen" element={<Servicemen />} />
          <Route path='/servicemanwork/:id' element={<ServiceManWorkDetails/>}/>


          {/* category */}
          <Route path="/category" element={<CategoryList />} />
          <Route path="/category/add" element={<AddCategory />} />
          <Route path="/category/update/:id" element={<UpdateCategory />} />

          {/* end here */}


          {/* banner */}
          <Route path="/banner" element={<BannerList />} />
          <Route path="/banner/add" element={<AddBanner />} />
          <Route path="/banner/update/:id" element={<UpdateBanner />} />

          {/* live video */}
          <Route path="/live-video" element={<LiveVideoList />} />
          <Route path="/live-video/add" element={<AddLiveVideo />} />




          {/* billing */}
          <Route path="/billing" element={<CreateBill />} />
          <Route path="/billing-list" element={<BillList />} />
          <Route path="/billing/details/:id" element={<BillDetails />} />






          {/* customer order list */}
          <Route path="/customerorder" element={<CorderList />} />
          <Route path="/withdrawel" element={<Withdrawel />} />

          {/* gussingnumber  list */}
          <Route path="/gussingnumber" element={<ListNumber />} />

          {/* gussingnumber  list */}
          <Route path="/qrcode" element={<QrCodeList />} />

          {/* gamebid  list */}
          <Route path="/gamebids" element={<GameBids />} />
          <Route path="/gamebidsbycustomer/:id" element={<ListPlay />} />

          {/* Question */}
          <Route path="/questions" element={<QuestionList />} />
          <Route path="/questions/add" element={<AddQuestions />} />
          <Route path="/questions/update/:id" element={<QuestionUpdate />} />

           <Route path="/tracking/update/:id" element={<LiveTracking />} />


          <Route path="/*" element={<h1>No page avaliable</h1>} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;
